import { gql } from 'graphql-request';

const verifyCaptcha = gql`
  mutation verifyCaptcha($token: String!, $hostname: String!) {
    verifyCaptcha(input: { token: $token, host: $hostname }) {
      success
      challengeTs
      hostname
      action
      errors {
        field
        messages
      }
    }
  }
`;

export default verifyCaptcha;
